import React from 'react'
import { ModalOverlay, ModalContent, ErrorMessage } from './style'

const ErrorModal = ({ isOpen, message }) => {
  if (!isOpen) return null

  return (
    <ModalOverlay>
      <ModalContent onClick={e => e.stopPropagation()} id='modal-content'>
        <ErrorMessage
          dangerouslySetInnerHTML={{ __html: message }}
        ></ErrorMessage>
      </ModalContent>
    </ModalOverlay>
  )
}

export default ErrorModal
